import { api } from "./api";

export const Question = async (data)=>{
    return api.post(`/questions/store`,data)
}